import React from 'react';
import { iconHelp } from 'react-project/assets/Icons';

export const HelpLogo = () => {
  return <div>{iconHelp}</div>;
};
